import { useOptionalDetailVisible } from 'context/dash/DetailVisible';
import { canInEvent, grantedLabels, isCollaboration } from 'helpers/eventCollaboration';

/**
 * O que a pessoa pode no evento aberto no painel. No evento próprio é tudo;
 * no evento em que só colabora (`collaboration` vem da lista do painel) é o
 * que o convite liberou.
 */
export default function useEventAccess() {
    const { detailVisible } = useOptionalDetailVisible();

    return {
        isCollaboration: isCollaboration(detailVisible),
        owner: detailVisible?.collaboration?.owner || null,
        grantedLabels: grantedLabels(detailVisible),
        can: (...permissions) => canInEvent(detailVisible, ...permissions),
    };
}
